/** Utils namespace
 * @namespace
 */
export const Utils = {
    /**Post message to the provided domain 
     * @param {string} domain - The domain where the messaged will be posted
     * @param {string} actionType - Action type
     * @param {string} payload - Payload
    */

    postMessage: (domain, actionType, payload) => {

        let win = window.frames.target;

        let data = {
            action: actionType,
            payload: payload
        }

        win.postMessage(JSON.stringify(data), `${window.location.protocol}//${domain}`);
    },

    checkTimeZone(z) {
        return z > 0 ? "-" + z : z * -1;
    },

    getTimeZone() {
        const date = new Date();
        let timeZone = date.getTimezoneOffset() / 60;
        return this.checkTimeZone(timeZone);
    },

    /** Move item in array
     * @param {string} from - The start position moved
     * @param {string} to - The array  where item will be moved
     * @param {string} result - Array
    */

    move: (from, to, ...a) => a.splice(to, 0, ...a.splice(from, 1)),

    insert: (arr, index, newItem) => [...arr.slice(0, index), newItem, ...arr.slice(index)],

    numberWithCommas: (value) => {
        const str = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const splited = str.split('.');
        if (splited.length > 1) {
            splited[splited.length - 1] = splited[splited.length - 1].replace(',', '');
        }
        return splited.join('.');
    }
}



// WEBPACK FOOTER //
// ./src/services/Utlis.js